export default __webpack_public_path__ + "static/media/bg_device.74a1ebfe.png";